import { useEffect, useState } from 'react'
import { useDemoResources } from './useDemoResources'
import { useUserSchoolClasses } from './useUserSchoolClasses'

const useSchoolClassesOptions = () => {
  const { schoolClasses, isLoading, error } = useUserSchoolClasses()
  const {
    demoSchoolClasses,
    isLoading: isLoadingDemo,
    error: demoError,
  } = useDemoResources()
  const [schoolClassesOptions, setSchoolClassesOptions] = useState()

  useEffect(() => {
    if (Array.isArray(demoSchoolClasses) && Array.isArray(schoolClasses)) {
      setSchoolClassesOptions([
        ...demoSchoolClasses.map((schoolClass) => ({
          value: `/demoklass/${schoolClass.id}`,
          name: schoolClass.name,
        })),
        ...schoolClasses.map((schoolClass) => ({
          value: `/klass/${schoolClass.id}`,
          name: schoolClass.name,
        })),
      ])
    }
  }, [schoolClasses, demoSchoolClasses])

  return {
    schoolClassesOptions,
    error: error || demoError,
    isLoading: !error && !demoError && !(isLoading || isLoadingDemo),
  }
}

export { useSchoolClassesOptions }
